import React, { Component } from 'react'
import { Modal, Table } from 'react-bootstrap'
import { bool, func, object } from 'prop-types'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'
import axios from 'axios'
import slugify from 'slugify'
import FormData from 'form-data'

import {
  updateVideo
} from '../../actions'

import { getAuthToken } from '../../utils/sessionStorage'
import config from '../../config'

class ThumbnailsModal extends Component {
  constructor () {
    super()

    this.state = {
      dropzoneText: 'Arraste seus thumbnails para esta área ou clique para selecionar.'
    }

    this.onDrop = this.onDrop.bind(this)
    this.uploadThumbs = this.uploadThumbs.bind(this)
    this.addThumbToVideo = this.addThumbToVideo.bind(this)
  }
  onDrop (files) {
    this.uploadThumbs(files[0])
  }
  uploadThumbs (file) {
    let { video } = this.props

    // Request de autorização para API
    this.setState({
      dropzoneText: 'Autorizando upload...'
    })
    axios({
      method: 'post',
      headers: {'X-User-Token': getAuthToken()},
      url: `${config.url}/upload/cdn`,
      data: {
        base_key: video.id
      }
    })
      .then((res) => {
        this.setState({
          dropzoneText: 'Fazendo upload de thumbnail...'
        })
        let data = res.data

        // Tratamento de nome para upload pro s3
        let parts = file.name.split('.')
        let ext = parts[parts.length - 1]
        let regexp = new RegExp('\\.' + ext)
        let basename = file.name.replace(regexp, '')

        let metadata = {}
        metadata.upload_url = '//' + data.bucket + '.s3.amazonaws.com/'
        metadata.key = data.base_key + slugify(basename, '_') + '.' + ext

        metadata.public_url = '//cdn-videos-sp.overmediacast.com/' + metadata.key

        var formData = new FormData()
        formData.append('AWSAccessKeyId', data.accessKeyId)
        formData.append('Policy', data.policy)
        formData.append('Signature', data.signature)
        formData.append('key', metadata.key)
        formData.append('acl', 'public-read')
        formData.append('Content-Type', file.type)
        formData.append('success_action_status', '201')
        formData.append('file', file)
        axios({
          method: 'post',
          url: metadata.upload_url,
          headers: { 'content-type': 'multipart/form-data' },
          data: formData
        })
          .then((res) => {
            this.setState({
              dropzoneText: 'Upload feito com sucesso. Salvando...'
            })

            // Upload de thumbs na API
            let thumbnails = [{ url: metadata.public_url }]
            this.addThumbToVideo(thumbnails, video.campaign_id, video.id)
          })
          .catch((err) => {
            this.setState({
              dropzoneText: 'Ocorreu um erro fazendo o upload. Tente novamente.'
            })
          })
      })
      .catch((err) => {
        this.setState({
          dropzoneText: 'Upload não autorizado. Tente novamente.'
        })
      })
  }
  addThumbToVideo (thumbnails, campaignId, videoId) {
    let { updateVideo } = this.props
    axios({
      method: 'POST',
      url: `${config.url}/campaigns/${campaignId}/videos/${videoId}/thumbnails`,
      headers: {'X-User-Token': getAuthToken()},
      data: {
        thumbnails
      }
    })
      .then((res) => {
        this.setState({
          dropzoneText: 'Upload feito e salvo com sucesso! Pronto para novos uploads.'
        })
        let updatedVideo = res.data
        updateVideo(updatedVideo.campaign_id, updatedVideo)
      })
  }
  render () {
    let { show, close, video } = this.props
    return (
      <Modal show={show} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>Lista de thumbnails</Modal.Title>
        </Modal.Header>
        <Modal.Body className='clearfix'>
          <Table striped bordered condensed hover>
            <thead>
              <tr>
                <th>Thumbnails</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {video.thumbnails && video.thumbnails.map((thumb) => (
                <tr key={thumb.id}>
                  <td>
                    <img src={thumb.url} alt='' />
                  </td>
                  <td className='text-center' style={{ verticalAlign: 'middle' }}>
                    <a>remover</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <h4>Faça o upload dos thumbnails</h4>
          <hr />
          <Dropzone
            className='dropzone'
            multiple={false}
            onDrop={this.onDrop}
            accept='image/png, image/gif, image/jpeg'>
            <p>{this.state.dropzoneText}</p>
          </Dropzone>
        </Modal.Body>
      </Modal>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateVideo: (campaignId, updatedVideo) => {
      dispatch(updateVideo(campaignId, updatedVideo))
    }
  }
}

ThumbnailsModal.propTypes = {
  show: bool,
  close: func,
  video: object,
  updateVideo: func
}

export default connect(null, mapDispatchToProps)(ThumbnailsModal)



// WEBPACK FOOTER //
// ./src/components/modals/ThumbnailsModal.js